import React, { useMemo } from 'react';
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import ChartFrame, { TOOLTIP_STYLE } from './ChartFrame';
import { bucketByDay, formatRangeLabel } from '../dateRange';
import { fmtNumber } from '../derive';

// New host signups over time. Uses an area chart for stronger at-a-glance
// trend readability vs. the previous line chart.
export default function CanvasGrowth({ filteredHosts, range, filters }) {
  const series = useMemo(
    () => bucketByDay(filteredHosts, (h) => h.createdAt, range.start, range.end),
    [filteredHosts, range]
  );
  const total = series.reduce((s, b) => s + b.count, 0);

  return (
    <ChartFrame
      title="New host signups"
      subtitle={`By day · ${formatRangeLabel(filters.range, filters.customStart, filters.customEnd)}`}
      right={
        <span className="rounded-md bg-zinc-100 px-1.5 py-0.5 text-[10px] font-semibold tabular-nums text-zinc-700">
          {fmtNumber(total)} total
        </span>
      }
    >
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={series} margin={{ top: 8, right: 8, bottom: 0, left: -16 }}>
          <defs>
            <linearGradient id="growthFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#6366f1" stopOpacity={0.25} />
              <stop offset="100%" stopColor="#6366f1" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#f4f4f5" vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 10, fill: '#71717a' }} interval="preserveEnd" />
          <YAxis tick={{ fontSize: 10, fill: '#71717a' }} allowDecimals={false} />
          <Tooltip contentStyle={TOOLTIP_STYLE} />
          <Area
            type="monotone"
            dataKey="count"
            stroke="#6366f1"
            strokeWidth={2}
            fill="url(#growthFill)"
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </ChartFrame>
  );
}
